import React, { memo, useState, useEffect, useCallback, useMemo } from 'react';
import Loading from '@gp/components/Loading';
import NoData from "@gp/components/NoData";
// @ts-ignore
import { LineEchart as BarLineEchart } from '@gp/components/CustomEchart';
import Filter, { IFilter } from '@gp/pages/StudioDashboard/StudioOverall/Tabs/People/Details/components/Filter';
import { getFormatNumPlus } from '@gp/utils/common';
import { getEChartOpt, tootipFormatter } from './utils/common';
import { useMemoizedFn } from 'ahooks';
import moment from 'moment';
import './index.scss';

interface BarEchartConProps {
  loading: boolean;
   // 总数居条数
   total: number;
  data: {
    'date': string,
    'others': string,
    'total_budget': string,
    [keyName: string]: string,
  }[] | null;
  keysMap: {
    'metric': string[], // 指标名称
    'metric_key': string[], // 对应字段名称
  };
  onChange: (
    payload: {
      start_date: string,
      end_date: string,
    },
  ) => void;
  [keyName: string]: any;
}

function BarEchartCon(props: BarEchartConProps) {
  const {
    loading,
    total,
    data,
    keysMap,
    onChange,
  } = props;

  const [filter, setFilter] = useState<IFilter>({
    date_type: 'Month',
    start_date: '',
    end_date: '',
  });

  const handleFilterChange = useMemoizedFn((payload: IFilter) => {
    const newFilter = { ...filter, ...payload };
    setFilter(newFilter);
    // 请求接口
    onChange({
      start_date: payload?.start_date || '',
      end_date: payload?.end_date || '',
    });
  });

  const getYAxisLeftMaxText = useCallback((v: any) => {
    const res = getFormatNumPlus(v, 2, false);
    return res;
  }, []);

  const options = useMemo(() => {
    return getEChartOpt(
      data,
      keysMap,
      getYAxisLeftMaxText,
      total,
    );
  }, [data]);

  // 初始化默认日期，默认选当前月份及往后11个月
  useEffect(() => {
    const initEndDate = moment().endOf('month').format('YYYY-MM-DD');
    const initStartDate = moment(initEndDate, 'YYYY-MM-DD')
      .subtract(11, 'months')
      .startOf('month')
      .format('YYYY-MM-DD');
    if (!filter?.start_date && !filter?.end_date) {
      setFilter({
        date_type: 'Month',
        start_date: initStartDate,
        end_date: initEndDate,
      });
      // 请求接口
      onChange({
        start_date: initStartDate,
        end_date: initEndDate,
      });
    }
  }, []);

  return (
    <div className="dbg-studio-overall-projects-development-budget-trend-content">
      <Filter
        dateRangeData={{
          start_date: '1970-01-01',
          end_date: `${moment().format('YYYY')}-12-31`,
        }}
        filter={filter}
        isLimitMaxSelectRange
        onFilterChange={handleFilterChange}
      />
      {loading ? (<Loading loading style={{height: 260, marginTop: 20}} />) :
      (!data || !data?.length) ? (<NoData height={200} constomStyle={{fontSize: 14}} />) : (
        <BarLineEchart
          options={options}
          // xAxisData={}
          fontSize={12}
          tootipFormatter={tootipFormatter}
          style={{height: '281.5px', width: '100%', marginTop: 20}}
        />
      )}
    </div>
  )
}

BarEchartCon.defaultProps = {
  loading: true,
  data: null,
  onChange: null,
}

export default memo(BarEchartCon);

